import './Statistics.css';
import { useState, useEffect, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { PageTitleBar } from '../layout/PageBar';
import {
    ModemStatisticDataList,
    ModemStatisticListSchema,
    StatisticGetModemStatisticRequestData
} from '../../api/Statistic';
import { APIRequestPost } from '../../utils/APIRequests';

function ModemsStatistic(): ReactNode {
    const { t } = useTranslation(['nav_menu']);
    const [info, setInfo] = useState<ModemStatisticDataList>([]);
    const [searchImei, setSearchImei] = useState<string>("");
    const [searchEmail, setSearchEmail] = useState<string>("");

    function getModemsStatistic() {
        const data: StatisticGetModemStatisticRequestData = {
            imei: searchImei,
            email: searchEmail
        };

        APIRequestPost('/statistic/getModemsStatistic', {
            data: data,
            schema: ModemStatisticListSchema,
            logSuccess: true
        }).then((result) => {
            setInfo(result.data);
        });
    }

    useEffect(() => {
        console.log("statistic modems mount");
        getModemsStatistic();
    }, []);

    return (
        <>
        <PageTitleBar title={t('modems_statistic')} />
        <div className='max-width text-page-padding'>
            {info &&
                <table
                    className='table table-striped'
                    aria-labelledby="tableLabel"
                    style={{ tableLayout: "fixed" }}
                >
                    <thead>
                        <tr>
                            <th style={{ width: "15%" }}>IMEI</th>
                            <th style={{ width: "17%" }}>User</th>
                            <th style={{ width: "30%" }}>Comment</th>
                            <th style={{ width: "15%" }}>Lifetime min</th>
                            <th style={{ width: "8%" }}>ID</th>
                            <th style={{ width: "10%" }}>Version</th>
                            <th style={{ width: "8%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="key">
                            <td>
                                <Form.Control
                                    type="text"
                                    defaultValue={searchImei}
                                    onChange={(event) => { setSearchImei(event.target.value) }}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    defaultValue={searchEmail}
                                    onChange={(event) => { setSearchEmail(event.target.value) }}
                                />
                            </td>
                            <td style={{ fontSize: "15px" }}></td>
                            <td></td>
                            <td></td>
                            <td>
                                <button
                                    style={{ width: "100%" }}
                                    className="btn btn-danger"
                                    onClick={() => { getModemsStatistic(); }}
                                >
                                    Find
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        {info.map(i =>
                            <tr key={i.imei}>
                                <td><Link to={`/statistics/modem?imei=${i.imei}`}>{i.imei}</Link></td>
                                <td>{i.userName}</td>
                                <td style={{ fontSize: "15px" }}>{i.comment}</td>
                                <td>{i.lifetime}</td>
                                <td>{i.name}</td>
                                <td>{i.version}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            }
        </div>
        </>
    )
}

export default ModemsStatistic;